<template>
  <div>

  <v-slide-y-transition mode="out-in">

    <v-container fluid grid-list-xl text-xs-center>

      <h1 class="page-title display-1">{{ getTitle() }}</h1>

      <v-layout row justify-space-between  wrap>

        <v-flex xs12 sm12 md5 lg5 xl5>
          
          
          <vuetify-editable-form-card
            ref="commerce"
            :color="'primary'"
            v-if="isSuperadmin()"
            :toolbar-title="'Asignar a'"
            :items="assignTo"
            @on-click-button="onClickButton"
            @on-change="onChange"
            @on-add-item="onAddItem"
          ></vuetify-editable-form-card>
          <vuetify-equipment-aggregator
            ref="equipment_aggregator"
            :color="'primary'"
            :toolbar-title="'Equipo'"
            :list-title="'Agregar equipo'"
            :add-button-hover-text="'Pulsa para agregar un nuevo equipo'"
            :dialog-max-width="450"
            :dialog-toolbar-title="'Agregar equipo a instalar'"
            :text-field-label="'Título'"
            :text-field-rules="equipment.rules"
            :select-label="'Tipo'"
            :delete-button="!isView() && !isInstaller()"
            :can-edit="!isView()"
            :navigation-menu="false"
            :dialog-confirm-headline="'Eliminar equipo'"
            :dialog-confirm-text="'¿Seguro que quieres eliminar este equipo?'"
            :cancel-button="'Cancelar'"
            :confirm-button="'Confirmar'"
            :delete-icon-hover-text="'Pulsa para eliminar'"
            :rate-id="rateID.value || '0'"
            :equipments="bookingEquipments.value || []"
            :value.sync="bookingEquipments.value"
            :equipments-list="equipments"
            @on-add-equipment="onAddEquipment"
            @on-delete-equipment="deleteEquipment"
          >
          </vuetify-equipment-aggregator>
          <vuetify-phone-aggregator
            ref="phone_aggregator"
            :color="'primary'"
            :toolbar-title="'Teléfonos de contacto'"
            :list-title="'Agregar teléfono'"
            :add-button-hover-text="'Pulsa para agregar un nuevo teléfono'"
            :dialog-max-width="450"
            :dialog-toolbar-title="'Agregar teléfono cliente'"
            :text-field-label="'Teléfono'"
            :text-field-rules="phone.rules"
            :select-label="'Tipo'"
            :dialog-confirm-headline="'Eliminar teléfono'"
            :dialog-confirm-text="'¿Seguro que quieres eliminar este teléfono?'"
            :delete-button="!isView() && !isInstaller()"
            :navigation-menu="!isView() && !isInstaller()"
            :cancel-button="'Cancelar'"
            :confirm-button="'Confirmar'"
            :delete-icon-hover-text="'Pulsa para eliminar'"
            :phone-types="phone.types"
            :phones="phone.value || []"
            :value.sync="phone.value"
            @on-add-phone="onChangePhone"
            @on-delete-phone="onChangePhone"
          >
          </vuetify-phone-aggregator>
          <vuetify-signature-aggregator
            v-show="false"
            ref="signature"
            :color="'primary'"
            :toolbar-title="'Firma comercio'"
            :list-title="'Agregar firma'"
            :add-button-hover-text="'Pulsa para agregar una nueva firma'"
            :dialog-max-width="670"
            :dialog-toolbar-title="signature.toolbar_title || ''"
            :dialog-confirm-headline="'Eliminar firma'"
            :dialog-confirm-text="'¿Seguro que quieres eliminar esta firma?'"
            :cancel-button="'Cancelar'"
            :confirm-button="'Confirmar'"
            :upload-icon-hover-text="'Subir imagen de 400 x 200 píxeles en formato PNG'"
            :clear-icon-hover-text="'Limpiar firma'"
            :save-icon-hover-text="'Guardar firma'"
            :delete-icon-hover-text="'Eliminar'"
            :options="signature || {}"
            :persistent="false"
            :value.sync="signature.value"
            :disable-delete-button="true"
            :disable-clear-button="true"
            :disable-cancel-button="true"
            :disable-upload-button="true"
            :disable-save-button="true"
            @on-upload-error="onUploadError"
            @on-add-signature="onChangeSignature(signature)"
          >
          </vuetify-signature-aggregator>
          <vuetify-observation-aggregator
            v-if="(isView() && observation.items.length) || !isView()"
            :color="'primary'"
            :toolbar-title="'Notas'"
            :list-title="'Agregar nota'"
            :add-button-hover-text="'Pulsa para agregar una nueva nota'"
            :dialog-max-width="450"
            ref='observation_aggregator'
            :dialog-toolbar-title="'Agregar '"
            :delete-button="!isView() && isSuperadmin()"
            :can-edit="!isView()"
            :text-field-label="'Título'"
            :text-field-rules="observation.rules"
            :select-label="'Tipo'"
            :dialog-confirm-headline="'Eliminar nota'"
            :dialog-confirm-text="'¿Seguro que quieres eliminar esta nota?'"
            :cancel-button="'Cancelar'"
            :confirm-button="'Confirmar'"
            :delete-icon-hover-text="'Pulsa para eliminar'"
            :observations="observation.items || []"
            :value.sync="observation.value"
            @on-add-observation="onAddObservation"
            @on-delete-observation="deleteObservation"
          >
          </vuetify-observation-aggregator>
          <vuetify-document-aggregator
            v-if="(isView() && documents.items.length) || !isView()"
            :color="'primary'"
            ref="document_aggregator"
            :toolbar-title="'Documentos'"
            :delete-button="isSuperadmin()"
            :list-title="'Agregar documento'"
            :add-button-hover-text="'Pulsa para agregar un nuevo documento'"
            :dialog-max-width="450"
            :dialog-toolbar-title="documents.dialog_toolbar_title"
            :text-field-label="'Título'"
            :text-field-rules="documents.rules"
            :select-label="'Tipo'"
            :dialog-confirm-headline="'Eliminar documento'"
            :dialog-confirm-text="'¿Seguro que quieres eliminar este documento?'"
            :cancel-button="'Cancelar'"
            :confirm-button="'Confirmar'"
            :delete-icon-hover-text="'Pulsa para eliminar'"
            :documents="documents.items || []"
            :value.sync="documents.value"
            @on-add-document="onAddDocument"
            @on-delete-document="deleteDocument"
          >
          </vuetify-document-aggregator>
          <vuetify-editable-form-card
            :color="'primary'"
            v-show="!isInstaller()"
            :toolbar-title="'Factura de compra'"
            :items="invoice"
            @on-click-button="onClickButton"
            @on-change="onChange"
            @on-add-item="onAddItem"
          ></vuetify-editable-form-card>
          <vuetify-editable-form-card
            :color="'primary'"
            v-show="isInstaller()"
            :toolbar-title="'Solicitar nueva instalación'"
            :items="newInstallation"
            @on-click-button="onClickButton"
            @on-change="onChange"
            @on-add-item="onAddItem"
          ></vuetify-editable-form-card>
          <vuetify-editable-form-card
            :color="'primary'"
            v-show="isSuperadmin()"
            :toolbar-title="'Solicitar'"
            :items="requestImages"
            @on-click-button="onClickButton"
            @on-change="onChange"
            @on-add-item="onAddItem"
          ></vuetify-editable-form-card>
          <v-card 
            v-if="isSuperadmin()"
            class="vuetify-aggregator-card" tile>
            <v-toolbar color="primary" dark>
              <v-toolbar-title>Aviso de instalación</v-toolbar-title>
              <v-spacer></v-spacer>
            </v-toolbar>
            <v-card-text>
              <v-btn slot="activator"dark outline color="primary" @click="onClickButton({ ref: 'email-doc-4' })">
                Enviar a comerciante
              </v-btn>
            </v-card-text>
          </v-card>
          <v-card 
            v-if="isCommerce()"
            class="vuetify-aggregator-card" tile>
            <v-toolbar color="primary" dark>
              <v-toolbar-title>Felicitar al instalador</v-toolbar-title>
              <v-spacer></v-spacer>
            </v-toolbar>
            <v-card-text>
              <v-btn slot="activator"dark outline color="primary" @click="congratulations()">
                Felicitar
              </v-btn>
            </v-card-text>
          </v-card>
          <v-card
            class="vuetify-aggregator-card" tile>
            <v-toolbar color="primary" dark>
              <v-toolbar-title>Generar documentos</v-toolbar-title>
              <v-spacer></v-spacer>
            </v-toolbar>
            <v-card-text>
              <v-btn slot="activator"dark outline color="primary" @click="generateDocument(1, true);">
                Conformidad cliente
              </v-btn>
              <v-spacer></v-spacer>
              <v-btn v-if="!isInstaller()" slot="activator"dark outline color="primary" @click="generateDocument(2, true);">
                PARTE A – ANEXO VI – R.D. 115/2017
              </v-btn>
              <v-spacer></v-spacer>
              <v-btn v-if="!isCommerce()" slot="activator"dark outline color="primary" @click="generateDocument(3, true);">
                PARTE B – ANEXO VI – R.D. 115/2017
              </v-btn>
              <v-spacer></v-spacer>
              <v-btn v-if="!isCommerce()" slot="activator"dark outline color="primary" @click="generateDocument(4, true);">
                AVISO DE INSTALACIÓN
              </v-btn>
              <v-spacer></v-spacer>
              <v-btn v-if="isSuperadmin()" slot="activator"dark outline color="primary" @click="generateDocument(5, true);">
                FICHERO REGISTRO
              </v-btn>
            </v-card-text>
          </v-card>
          <v-card
            class="vuetify-aggregator-card" tile>
            <v-toolbar color="primary" dark>
              <v-toolbar-title>Firmar documentos</v-toolbar-title>
              <v-spacer></v-spacer>
            </v-toolbar>
            <v-card-text>
              <v-btn slot="activator"dark outline color="primary" @click="generateDoc('signature', 1);">
                Conformidad cliente
              </v-btn>
              <v-spacer></v-spacer>
              <v-btn slot="activator"dark outline color="primary" @click="generateDoc('signature', 2);">
                PARTE A – ANEXO VI – R.D. 115/2017
              </v-btn>
              <v-spacer></v-spacer>
              <v-btn v-if="!isCommerce()" slot="activator"dark outline color="primary" @click="generateDoc('signature', 3);">
                PARTE B – ANEXO VI – R.D. 115/2017
              </v-btn>
            </v-card-text>
          </v-card>
        </v-flex>
        <v-flex xs12 sm12 md7 lg7 xl7>

          <vuetify-editable-form-card
            ref="commerce"
            :color="'primary'"
            :toolbar-title="'Estado de la instalación'"
            :items="installationStateForm"
            @on-click-button="onClickButton"
            @on-change="onChange"
            @on-add-item="onAddItem"
          ></vuetify-editable-form-card>
          <vuetify-editable-form-card
            ref="commerce"
            :color="'primary'"
            :toolbar-title="'Causas de la anulación'"
            v-show="showStateCauses"
            :items="installationStateCausesForm"
            @on-click-button="onClickButton"
            @on-change="onChange"
            @on-add-item="onAddItem"
          ></vuetify-editable-form-card>
          <vuetify-editable-form-card
            ref="fields"
            :color="'primary'"
            :toolbar-title="'Detalles de la instalación'"
            :items="installationInfo"
            @on-click-button="onClickButton"
            @on-change="onChange"
            @on-add-item="onAddItem"
          ></vuetify-editable-form-card>
          <vuetify-editable-form-card
            ref="fields"
            :color="'primary'"
            :toolbar-title="'Detalles de la venta'"
            :items="fields"
            v-show="!isInstaller()"
            @on-click-button="onClickButton"
            @on-change="onChange"
            @on-add-item="onAddItem"
          ></vuetify-editable-form-card>
          <vuetify-editable-form-card
            ref="fields"
            :color="'primary'"
            :toolbar-title="'Datos del cliente'"
            :items="customer"
            @on-click-button="onClickButton"
            @on-change="onChange"
            @on-add-item="onAddItem"
          ></vuetify-editable-form-card>
          <vuetify-editable-address-card
            :id="'address'"
            ref="editable_address_card_1"
            :color="'primary'"
            :navigation-menu="!isView() && !isInstaller()"
            :toolbar-title="'Dirección del cliente'"
            :dialog-toolbar-title="'Agregar dirección de cliente'"
            :placeholder="'Escribe la dirección'"
            :list-title="'Agregar dirección del cliente'"
            :route="route"
            :route-extras="routeExtras"
            :postalCode="postalCode"
            :locality="locality"
            :province="province"
            :place-id="placeID"
            @on-change="onChange"
          ></vuetify-editable-address-card>
          <v-slide-y-transition mode="out-in">
            <vuetify-editable-address-card
              :id="'address2'"
              ref="editable_address_card_2"
              :color="'primary'"
              :navigation-menu="!isView() && !isInstaller()"
              :toolbar-title="'Dirección de instalación'"
              :dialog-toolbar-title="'Agregar dirección'"
              :placeholder="'Escribe tu dirección'"
              :list-title="'Agregar dirección'"
              :route="routeDelivery"
              :route-extras="routeExtrasDelivery"
              :postalCode="postalCodeDelivery"
              :locality="localityDelivery"
              :province="provinceDelivery"
              :place-id="placeIdDelivery"
              @on-change="onChange"
            ></vuetify-editable-address-card>
          </v-slide-y-transition>
        </v-flex>
            <v-btn
              v-if="false"
              dark
              fab
              fixed
              bottom
              left
              color="primary"
              @click="returnToEquipments()"
            >
              <v-icon>arrow_back</v-icon>
            </v-btn>
            <v-btn
              v-if="false"
              dark
              fab
              fixed
              bottom
              right
              color="teal"
              @click="validateEquipment()"
            >
              <v-icon>check</v-icon>
            </v-btn>


      </v-layout>

      <v-btn
              dark
              v-if="isNew() && this.bookingEquipments && this.bookingEquipments.value && this.bookingEquipments.value.length"
              color="primary"
              @click="documentCreationdialog = !documentCreationdialog"
            >
              Finalizar
            </v-btn>

    </v-container>

  </v-slide-y-transition>

    <v-dialog v-if="isNew()" persistent slot="extras" v-model="calendar" max-width="800">
      <v-card height="600">
        <calendar ref="calendar" @on-assign-booking="onAssignBooking"></calendar>
      </v-card>
    </v-dialog>
    <div>
    <vuetify-stepper-dialog
    ref="stepper"
    @on-close="onCloseStepper"
    :items="steppers || []"
    :dialog="canCreateReservation && (isNew() || noAssignation) && display" 
    :max-width="600"
    @on-last-step="onLastStep"
    @on-next-step="onNextStep"
    @on-click-button="onClickButton"
    @on-change="onChange"
    @on-add-item="onAddItem"
  ></vuetify-stepper-dialog>
</div>
</div>
</template>

<script>
  import Rule from 'mixins/rule'
  import VisibleFor from '@/components/vue-user/visible-for'
  import Calendar from '@/components/calendar'
  import VuetifyEditableFormCard from '@/components/vuetify-editable-form-card'
  import VuetifyTextField from '@/components/vuetify-form-creator/fields/vuetify-text-field'
  import VuetifySelect from '@/components/vuetify-form-creator/fields/vuetify-select'
  import VuetifyPhoneAggregator from '@/components/vuetify-phone-aggregator'
  import VuetifyAvatarCard from '@/components/vuetify-avatar-card'
  import VuetifyEditableAddressCard from '@/components/vuetify-editable-address-card'
  import VuetifyObservationAggregator from '@/components/vuetify-observation-aggregator'
  import VuetifyDocumentAggregator from '@/components/vuetify-document-aggregator'
  import VuetifyEquipmentAggregator from '@/components/vuetify-equipment-aggregator'
  import VuetifySignatureAggregator from '@/components/vuetify-signature-aggregator'
  import VuetifyStepperDialog from '@/components/vuetify-stepper-dialog'

  export default {
    mixins: [Rule],

    components:
    {
      Calendar,
      VisibleFor,
      VuetifyEditableAddressCard,
      VuetifyPhoneAggregator,
      VuetifyEditableFormCard,
      VuetifyTextField,
      VuetifyAvatarCard,
      VuetifySelect,
      VuetifyObservationAggregator,
      VuetifyEquipmentAggregator,
      VuetifySignatureAggregator,
      VuetifyDocumentAggregator,
      VuetifyStepperDialog
    },

    data () {
      return {
        moment: require('moment'),
        route: {},
        canCreateReservation: true,
        routeExtras: {},
        postalCode: {},
        locality: {},
        province: {},
        newWindowContent: null,
        sendEmailDoc1: false,
        sendEmailDoc2: false,
        sendEmailDoc3: false,
        hasSerials: true,
        placeID: {},
        assignTo: [],
        routeDelivery: {},
        routeExtrasDelivery: {},
        postalCodeDelivery: {},
        localityDelivery: {},
        provinceDelivery: {},
        placeIdDelivery: {},
        commerceAlias: {},
        commerceCif: {},
        commerceAddress: {},
        commerceAddress2: {},
        commercePostalCode: {},
        commerceLocality: {},
        commerceProvince: {},
        commercePhone: {},
        commerceEmail: {},
        sellerName: {},
        saleSoldDate: {},
        saleDeliveryDate: {},
        saleID: {},
        statusID: {},
        calendar_visibility: {},
        installationStartDate: {},
        installationEndDate: {},
        status: {},
        generation: false,
        showStateCauses: false,
        addingSerials: false,
        documentCreationdialog: false,
        phone: {},
        sellerID: {},
        businessGroupType: '',
        businessGroupName: '',
        companyName: '',
        commerceType: '',
        commerceName: '',
        commerceAvatar: {},
        step1: false,
        step2: false,
        step3: false,
        end1: false,
        end2: false,
        end3: false,
        download1: false,
        download2: false,
        download3: false,
        signatureSuccess1: false,
        uploadSuccess1: false,
        updateDocument1: false,
        checkbox1: false,
        checkbox2: false,
        hasAssignation: false,
        noInstaller: false,
        noAssignation: false,
        installers: [],
        installerID: {},
        bookingEquipments: {},
        installerName: {},
        installerAlias: {},
        installerSurname: {},
        alias: {},
        rateID: {},
        commerceID: {},
        installerSignature: {},
        customerSignature: {},
        commerceSignature: {},
        signature: {
          toolbar_title: 'Agregar firma',
          value: null,
          booking_id: 0,
          user_id: 0,
          booking_document_url: '',
          booking_document_id: 0,
          booking_document_title: '',
          booking_document_filetype: '',
          booking_document_filename: ''
        },
        isSignature: false,
        customerID: {},
        addressCheckbox: {},
        sellers: [],
        documents: {
          type: 'select',
          assign_to: 'assignTo',
          editable: true,
          columns: 'xs12',
          label: 'Vendedor',
          item_text: 'seller_name',
          item_value: 'seller_id',
          dialog_toolbar_title: 'Agregar documento',
          items: [],
          rules: [],
          return_object: true,
          autocomplete: true
        },
        observation: {
          type: 'select',
          assign_to: 'assignTo',
          editable: true,
          columns: 'xs12',
          label: 'Vendedor',
          item_text: 'seller_name',
          item_value: 'seller_id',
          items: [],
          rules: [],
          return_object: true,
          autocomplete: true
        },
        sellersParams: {
          type: 'select',
          assign_to: 'fields',
          editable: true,
          ref: 'sellerID',
          columns: 'xs12',
          label: 'Vendedor',
          item_text: 'seller_name',
          item_value: 'seller_id',
          table: 'sellers',
          items: [],
          return_object: true,
          autocomplete: false
        },
        installationState: [
          {
            type: 'select',
            assign_to: 'assignTo',
            editable: true,
            columns: 'xs12',
            label: 'Vendedor',
            item_text: 'seller_name',
            item_value: 'seller_id',
            items: [],
            return_object: true,
            autocomplete: true
          }
        ],
        newInstallation: [
          {
            type: 'select',
            assign_to: 'newInstallation',
            editable: false,
            columns: 'xs12',
            label: 'Acabo aquí en',
            item_text: 'item_text',
            item_value: 'item_value',
            items: [
              {
                item_text: 'He acabado',
                item_value: 'He acabado aquí.'
              },
              {
                item_text: '15 minutos',
                item_value: 'Acabo aquí en 15 minutos.'
              },
              {
                item_text: '30 minutos',
                item_value: 'Acabo aquí en 30 minutos.'
              },
              {
                item_text: '45 minutos',
                item_value: 'Acabo aquí en 45 minutos.'
              },
              {
                item_text: '1 hora',
                item_value: 'Acabo aquí en 1 hora.'
              },
              {
                item_text: 'Hora y media',
                item_value: 'Acabo aquí en hora y media.'
              }
            ],
            return_object: true,
            value: '',
            update: true,
            autocomplete: true
          }
        ],
        invoice: [],
        invoiceForm: [
          {
            assign_to: 'invoice',
            type: 'button',
            columns: 'xs6',
            items: [
              {
                text_button: 'Subir factura',
                align: 'center',
                outline: true,
                ref: 'invoice-was-updated'
              }
            ]
          }
        ],
        requestImages: [
          {
            type: 'select',
            assign_to: 'requestImages',
            editable: false,
            columns: 'xs12',
            label: 'Solicitar',
            item_text: 'item_text',
            item_value: 'item_value',
            items: [
              {
                item_text: 'Fotografías de la instalación',
                item_value: 'Hacer fotografías a la instalación. En caso de no ser posible, agregar observación informando sobre el motivo.'
              }
            ],
            return_object: true,
            value: '',
            update: true,
            autocomplete: true
          }
        ],
        installationInfo: [],
        installationInfoForm: [
          {
            order: 0,
            type: 'date-picker',
            columns: 'xs12',
            rules: [
              'required'
            ],
            required: true,
            ref: 'installationStartDate',
            assign_to: 'installationInfo',
            label: 'Fecha inicio instalación'
          },
          {
            order: 0,
            type: 'date-picker',
            columns: 'xs12',
            rules: [
              'required'
            ],
            required: true,
            ref: 'installationEndDate',
            assign_to: 'installationInfo',
            label: 'Fecha fin instalación'
          },
          {
            order: 0,
            type: 'time-picker',
            columns: 'xs6',
            rules: [
              'required'
            ],
            required: true,
            ref: 'installationStartDate',
            assign_to: 'installationInfo',
            label: 'Hora de inicio'
          },
          {
            order: 0,
            type: 'time-picker',
            columns: 'xs6',
            rules: [
              'required'
            ],
            required: true,
            ref: 'installationEndDate',
            assign_to: 'installationInfo',
            label: 'Hora de finalización'
          }
        ],
        installationStateForm: [],
        installationStateCausesForm: [],
        steppers: [],
        calendar: false,
        bookingWasSearch: false,
        fields: [],
        customer: [],
        avatar: {},
        avatars: [],
        commerce: {},
        userID: {},
        equipments: {},
        equipment: [],
        equipmentID: null,
        currentStep: '',
        models: null,
        display: false,
        currentDocumentID: false
      }
    },

    created () {
      this.getSale().then((response) => {
        // console.log(response)
        this.normalizeAddress()
        this.normalizeAndAssign(response.data)

        console.log('........', this.avatar)

        if (!this.isSuperadmin()) {
          this.invoice[0].disabled = true
        }
        this.normalizeAndAssign(this.installationInfoForm)
        this.normalizeAndAssign(this.invoiceForm)
        if (parseInt(this.invoice[0].value) === 0) {
          this.invoice[0].value = false
        }
        let startDate = this.installationStartDate.value
        let endDate = this.installationEndDate.value
        if (this.$route.params.booking_start && this.$route.params.booking_end) {
          let start = this.$route.params.booking_start.split('_')
          let dateStart = start[0] || this.moment()
          let hourStart = start[1] || this.moment()
          startDate = dateStart + ' ' + hourStart
          let end = this.$route.params.booking_end.split('_')
          let dateEnd = end[0] || this.moment()
          let hourEnd = end[1] || this.moment()
          endDate = dateEnd + ' ' + hourEnd
        }

        if (startDate && endDate && startDate !== '0000-00-00 00:00:00' && endDate !== '0000-00-00 00:00:00') {
          this.installationInfo[0].value = this.moment(startDate).format('YYYY-MM-DD')
          this.installationInfo[1].value = this.moment(endDate).format('YYYY-MM-DD')
          this.installationInfo[2].value = this.moment(startDate).format('HH:mm')
          this.installationInfo[3].value = this.moment(endDate).format('HH:mm')
        } else {
          this.installationInfo[0].value = false
          this.installationInfo[1].value = null
          this.installationInfo[2].value = null
          this.installationInfo[3].value = null
        }

        if (this.isNew()) {
          // this.installationStartDate.value = this.moment(startDate).format('YYYY-MM-DD HH:mm')
          // this.installationEndDate.value = this.moment(endDate).format('YYYY-MM-DD HH:mm')
          this.installationStartDate.value = false
          this.installationEndDate.value = false
          // this.updateItem(this.installationStartDate, this.installationStartDate.value)
          // this.updateItem(this.installationEndDate, this.installationEndDate.value)
        }
        this.fields[0].value = this.moment(this.saleDeliveryDate.value || this.moment()).format('YYYY-MM-DD')
        this.fields[1].value = this.moment(this.saleSoldDate.value || this.moment()).format('YYYY-MM-DD')
        this.updateItem(this.fields[1], this.fields[1].value)
        this.bookingEquipments.value = JSON.parse(this.bookingEquipments.value)
        this.phone.value = JSON.parse(this.phone.value)

        let index = this.installationStateForm[0].items.findIndex((item) => {
          return parseInt(item.item_value) === parseInt(this.installationStateForm[0].value)
        })
        this.installationStateForm[0].value = this.installationStateForm[0].items[index]
        if (this.installationStateCausesForm[0].value && parseInt(this.installationStateForm[0].value.item_value) === 8) {
          this.showStateCauses = true
          index = this.installationStateCausesForm[0].items.findIndex((item) => {
            return parseInt(item.item_value) === parseInt(this.installationStateCausesForm[0].value)
          })

          this.installationStateCausesForm[0].value = this.installationStateCausesForm[0].items[index]
        }

        if (this.$route.params.booking_added && this.$route.params.booking_added === 'true') {
          this.updateItem(this.installationStateForm[0], '6')
          this.$store.dispatch('api/authRequest', {
            method: 'get',
            url: 'update-sale-status/' + this.bookingID.value + '/6/'
          }).then((response) => {
            if (this.isCommerce()) {
              // this.sendEmail('email-doc-4')
            }
            this.installationStateForm[0].value = this.installationStateForm[0].items[0]
            console.log('STATUS UPDATE', response)
          })
          this.onFinish()
        }
        this.getEquipments().then((response) => {
          // console.log(response)
          if (!response.data.items || response.data.items.length === 0) {
            this.canCreateReservation = false
            this.$awn.warning('Imposible crear reservas. No existen equipos disponibles en el sistema.')
            return false
          }
          this.equipments = response.data

          console.log('EQUIPMENTS', this.equipments)
          this.getDocuments().then((response) => {
            this.getObservations().then((response) => {
              // console.log(response)
              this.getCommerceSellers().then((response) => {
                // console.log(response)
                this.getCommerces().then((response) => {
                  // console.log(response)
                  if (!response.data.items || response.data.items.length === 0) {
                    this.canCreateReservation = false
                    this.$awn.warning('Imposible crear reservas. No existen comercios activos en el sistema.')
                    return false
                  }
                  this.getInstallers().then((response) => {
                    if (!response.data.items || response.data.items.length === 0) {
                      this.canCreateReservation = false
                      this.$awn.warning('Imposible crear reservas. No existen instaladores activos en el sistema.')
                      return false
                    }
                    this.hasSerials = false
                    if (
                      this.bookingEquipments.value[0] &&
                      this.bookingEquipments.value[0].serial_indoor_unit_1 &&
                      this.bookingEquipments.value[0].serial_indoor_unit_1 !== '' &&
                      this.bookingEquipments.value[0].serial_indoor_unit_2 &&
                      this.bookingEquipments.value[0].serial_indoor_unit_2 !== '' &&
                      this.bookingEquipments.value[0].serial_outdoor_unit_1 &&
                      this.bookingEquipments.value[0].serial_outdoor_unit_1 !== ''
                    ) {
                      this.hasSerials = true
                    }
                    console.log('dddddddddd', this.hasSerials)
                    this.setSteps()
                    if (this.isSuperadmin()) {
                      if (!this.installationInfo[4].value) {
                        this.noInstaller = true
                      }
                      this.setSteps()
                      if (!this.isAssignated()) {
                        this.noAssignation = true
                      }
                      setTimeout(() => { this.display = true }, 100)
                    } else {
                      console.log('[][][][][][][]', this.installationInfo[4].value)
                      this.installationInfo[0].disabled = true
                      this.installationInfo[1].disabled = true
                      this.installationInfo[2].disabled = true
                      this.installationInfo[3].disabled = true
                      this.installationInfo[4].disabled = true
                      if (this.isInstaller()) {
                        this.installationInfo[4].type = 'hidden'
                        this.customer[0].disabled = true
                        this.customer[1].disabled = true
                        this.customer[2].disabled = true
                        this.customer[3].disabled = true
                        this.route.disabled = true
                        this.routeExtras.disabled = true
                        this.postalCode.disabled = true
                        this.locality.disabled = true
                        this.province.disabled = true
                        this.routeDelivery.disabled = true
                        this.routeExtrasDelivery.disabled = true
                        this.postalCodeDelivery.disabled = true
                        this.localityDelivery.disabled = true
                        this.provinceDelivery.disabled = true
                      }
                      setTimeout(() => { this.display = true }, 100)
                    }
                    console.log('COPME', this.assignTo)
                  }).catch((error) => {
                    console.log(error)
                  })
                }).catch((error) => {
                  console.log(error)
                })
              }).catch((error) => {
                console.log(error)
              })
            }).catch((error) => {
              console.log(error)
            })
          })
        }).catch((error) => {
          console.log(error)
        })
      }).catch((error) => {
        console.log(error)
      })
    },

    methods:
    {

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      isInstaller () {
        return this.$store.getters['api/getUserRol'] === 'installer'
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      isCommerce () {
        return this.$store.getters['api/getUserRol'] === 'commerce'
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      setAdminSteps () {
        this.steppers = [
          {
            ref: 'advise',
            fields: this.normalizeAndAssign([
              {
                assign_to: 'unknown',
                type: 'section-text',
                append_icon: 'check_circle',
                icon_color: 'teal',
                columns: 'xs12 sm12 md12 lg12',
                value: '1. CONFORMIDAD DE CLIENTE.'
              },
              {
                type: 'section-text',
                append_icon: 'check_circle',
                icon_color: 'teal',
                assign_to: 'unknown',
                columns: 'xs12 sm12 md12 lg12',
                value: '2. PARTE A – ANEXO VI – R.D. 115/2017.'
              },
              {
                type: 'section-text',
                append_icon: 'check_circle',
                icon_color: 'teal',
                assign_to: 'unknown',
                columns: 'xs12 sm12 md12 lg12',
                value: '3. PARTE B – ANEXO VI – R.D. 115/2017.'
              },
              {
                type: 'section-text',
                append_icon: 'check_circle',
                icon_color: 'gray',
                assign_to: 'unknown',
                columns: 'xs12 sm12 md12 lg12',
                value: '4. AVISO DE INSTALACIÓN.'
              },
              {
                assign_to: 'unknown',
                type: 'section-text',
                columns: 'xs12 sm12 md12 lg12',
                append_icon: 'help_outline',
                icon_color: 'primary',
                value: 'ATENCIÓN: Esta reserva no tiene fecha de instalación o instalador asignado. Pulsa en "Siguiente" para seleccionar un instalador y confirmar la fecha de la reserva.'
              }
            ]),
            requestImagesOnNew: {},
            title: 'Generar documentos',
            text: 'Siguiente',
            icon_hidden: true
          },
          {
            ref: 'installer',
            fields: [
              this.installationInfo[4]
            ],
            title: 'Asignar al instalador'
          },
          {
            ref: 'installationInfo',
            fields: [
              this.installationInfo[0],
              this.installationInfo[1],
              this.installationInfo[2],
              this.installationInfo[3]
            ],
            title: 'Fecha y hora de la instalación'
          },
          {
            ref: 'advise',
            fields: this.normalizeAndAssign([
              {
                assign_to: 'unknown',
                type: 'section-text',
                append_icon: 'check_circle',
                icon_color: 'teal',
                columns: 'xs12 sm12 md12 lg12',
                value: '1. CONFORMIDAD DE CLIENTE.'
              },
              {
                type: 'section-text',
                append_icon: 'check_circle',
                icon_color: 'teal',
                assign_to: 'unknown',
                columns: 'xs12 sm12 md12 lg12',
                value: '2. PARTE A – ANEXO VI – R.D. 115/2017.'
              },
              {
                type: 'section-text',
                append_icon: 'check_circle',
                icon_color: 'teal',
                assign_to: 'unknown',
                columns: 'xs12 sm12 md12 lg12',
                value: '3. PARTE B – ANEXO VI – R.D. 115/2017.'
              },
              {
                type: 'section-text',
                append_icon: 'check_circle',
                icon_color: 'teal',
                assign_to: 'unknown',
                columns: 'xs12 sm12 md12 lg12',
                value: '4. AVISO DE INSTALACIÓN.'
              },
              {
                assign_to: 'unknown',
                type: 'section-text',
                columns: 'xs12 sm12 md12 lg12',
                append_icon: 'help_outline',
                icon_color: 'primary',
                value: 'Los documentos se han generado correctamente. Puedes finalizar para ver los detalles de la reserva o enviar el aviso de instalación al comerciante. No es necesario enviar el aviso al instalador, el sistema lo enviará de forma automática 24 horas antes (48 horas si hay fiesta entre medio).'
              },
              {
                assign_to: 'unknown',
                type: 'button',
                columns: 'xs12 sm12 md12 lg12',
                items: [
                  {
                    text_button: 'Finalizar',
                    align: 'right',
                    outline: true,
                    ref: 'finish-booking'
                  },
                  {
                    text_button: 'Enviar aviso a comerciante',
                    align: 'right',
                    outline: true,
                    loading: false,
                    disabled: false,
                    ref: 'email-doc-4'
                  }
                ]
              }
            ]),
            requestImagesOnNew: {},
            title: 'Generar documentos',
            text: 'Siguiente',
            button_hidden: true,
            icon_hidden: true
          }
        ]
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      setInstallerSteps () {
        this.steppers = [
          {
            ref: 'advise',
            fields: this.normalizeAndAssign([
              {
                assign_to: 'unknown',
                type: !this.isSuperadmin() ? 'hidden' : 'section-text',
                append_icon: 'check_circle',
                icon_color: 'teal',
                columns: 'xs12 sm12 md12 lg12',
                value: '1. CONFORMIDAD DE CLIENTE.'
              },
              {
                type: !this.isSuperadmin() ? 'hidden' : 'section-text',
                append_icon: 'check_circle',
                icon_color: 'teal',
                assign_to: 'unknown',
                columns: 'xs12 sm12 md12 lg12',
                value: '2. PARTE A – ANEXO VI – R.D. 115/2017.'
              },
              {
                type: 'section-text',
                append_icon: 'check_circle',
                icon_color: 'gray',
                assign_to: 'unknown',
                columns: 'xs12 sm12 md12 lg12',
                value: '3. PARTE B – ANEXO VI – R.D. 115/2017.'
              },
              {
                assign_to: 'unknown',
                type: 'section-text',
                columns: 'xs12 sm12 md12 lg12',
                append_icon: 'help_outline',
                icon_color: 'primary',
                value: 'ATENCIÓN: Antes de firmar o generar el parte B deben agregarse los números de serie.'
              },
              {
                assign_to: 'unknown',
                type: 'button',
                columns: 'xs12 sm12 md12 lg12',
                items: [
                  {
                    text_button: 'Agregar números de serie',
                    align: 'right',
                    outline: true,
                    ref: 'serial-numbers'
                  }
                ]
              }
            ]),
            requestImagesOnNew: {},
            title: 'Generar documentos',
            text: 'Siguiente',
            icon_hidden: true
          },
          {
            ref: 'customer_signature',
            fields: this.normalizeAndAssign([
              {
                assign_to: 'unknown',
                type: !this.isSuperadmin() ? 'hidden' : 'section-text',
                append_icon: 'check_circle',
                icon_color: 'teal',
                columns: 'xs12 sm12 md12 lg12',
                value: '1. CONFORMIDAD DE CLIENTE.'
              },
              {
                type: !this.isSuperadmin() ? 'hidden' : 'section-text',
                append_icon: 'check_circle',
                icon_color: 'teal',
                assign_to: 'unknown',
                columns: 'xs12 sm12 md12 lg12',
                value: '2. PARTE A – ANEXO VI – R.D. 115/2017.'
              },
              {
                type: 'section-text',
                append_icon: 'check_circle',
                icon_color: 'gray',
                assign_to: 'unknown',
                columns: 'xs12 sm12 md12 lg12',
                value: '3. PARTE B – ANEXO VI – R.D. 115/2017.'
              },
              {
                assign_to: 'unknown',
                type: 'button',
                columns: 'xs12 sm12 md12 lg12',
                items: [
                  {
                    text_button: 'Imprimir y firmar',
                    align: 'right',
                    outline: true,
                    ref: 'upload-doc-3'
                  },
                  {
                    text_button: 'GENERAR y firmar en pantalla',
                    align: 'right',
                    outline: true,
                    open_new_window: true,
                    ref: 'signature-doc-3'
                  }
                ]
              }
            ]),
            title: 'Generar documentos',
            button_hidden: true
          },
          {
            ref: 'customer-advise',
            fields: this.normalizeAndAssign([
              {
                assign_to: 'unknown',
                type: !this.isSuperadmin() ? 'hidden' : 'section-text',
                append_icon: 'check_circle',
                icon_color: 'teal',
                columns: 'xs12 sm12 md12 lg12',
                value: '1. CONFORMIDAD DE CLIENTE.'
              },
              {
                type: !this.isSuperadmin() ? 'hidden' : 'section-text',
                append_icon: 'check_circle',
                icon_color: 'teal',
                assign_to: 'unknown',
                columns: 'xs12 sm12 md12 lg12',
                value: '2. PARTE A – ANEXO VI – R.D. 115/2017.'
              },
              {
                type: 'section-text',
                append_icon: 'check_circle',
                icon_color: 'teal',
                assign_to: 'unknown',
                columns: 'xs12 sm12 md12 lg12',
                value: '3. PARTE B – ANEXO VI – R.D. 115/2017.'
              },
              {
                assign_to: 'unknown',
                type: 'section-text',
                columns: 'xs12 sm12 md12 lg12',
                append_icon: 'check',
                icon_color: 'teal',
                value: 'El documento se ha actualizado correctamente.'
              },
              {
                assign_to: 'unknown',
                type: 'section-text',
                columns: 'xs12 sm12 md12 lg12',
                append_icon: 'help_outline',
                icon_color: 'primary',
                value: 'Aconsejamos entregar al cliente una copia del parte B firmada.'
              },
              {
                assign_to: 'unknown',
                type: this.customer[3].value ? 'button' : 'hidden',
                columns: 'xs12 sm12 md12 lg12',
                items: [
                  {
                    text_button: 'Enviar por email',
                    align: 'right',
                    outline: true,
                    ref: 'email-doc-3'
                  }
                ]
              },
              {
                assign_to: 'unknown',
                type: 'checkbox',
                columns: 'xs12 sm12 md12 lg12',
                label: 'Se ha entregado/enviado al cliente una copia firmada.',
                value: false,
                required: true,
                rules: [
                  'is_true'
                ]
              }
            ]),
            requestImagesOnNew: {},
            title: 'Generar documentos',
            text: 'Siguiente',
            icon_hidden: true
          },
          {
            ref: 'advise',
            fields: this.normalizeAndAssign([
              {
                assign_to: 'unknown',
                type: !this.isSuperadmin() ? 'hidden' : 'section-text',
                append_icon: 'check_circle',
                icon_color: 'teal',
                columns: 'xs12 sm12 md12 lg12',
                value: '1. CONFORMIDAD DE CLIENTE.'
              },
              {
                type: !this.isSuperadmin() ? 'hidden' : 'section-text',
                append_icon: 'check_circle',
                icon_color: 'teal',
                assign_to: 'unknown',
                columns: 'xs12 sm12 md12 lg12',
                value: '2. PARTE A – ANEXO VI – R.D. 115/2017.'
              },
              {
                type: 'section-text',
                append_icon: 'check_circle',
                icon_color: 'teal',
                assign_to: 'unknown',
                columns: 'xs12 sm12 md12 lg12',
                value: '3. PARTE B – ANEXO VI – R.D. 115/2017.'
              },
              {
                type: 'section-text',
                append_icon: 'check_circle',
                icon_color: 'teal',
                assign_to: 'unknown',
                columns: 'xs12 sm12 md12 lg12',
                value: '4. AVISO DE INSTALACIÓN.'
              },
              {
                assign_to: 'unknown',
                type: 'section-text',
                columns: 'xs12 sm12 md12 lg12',
                append_icon: 'help_outline',
                icon_color: 'primary',
                value: 'Los documentos se han generado correctamente.'
              },
              {
                assign_to: 'unknown',
                type: 'button',
                columns: 'xs12 sm12 md12 lg12',
                items: [
                  {
                    text_button: 'Aceptar',
                    align: 'right',
                    outline: true,
                    ref: 'finish-serials'
                  }
                ]
              }
            ]),
            requestImagesOnNew: {},
            title: 'Generar documentos',
            text: 'Finalizar',
            icon_hidden: true
          }
        ]
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      setSteps () {
        if (this.isSuperadmin() && !this.isNew() && (!this.installationInfo[0].value || !this.installationInfo[1].value || !this.installationInfo[2].value || !this.installationInfo[3].value || !this.installationInfo[4].value)) {
          return this.setAdminSteps()
        }
        let phoneExists1 = this.phone.value && this.phone.value[0] !== undefined
        let phoneExists2 = this.phone.value && this.phone.value[1] !== undefined
        let phoneExists3 = this.phone.value && this.phone.value[2] !== undefined
        let equipmmentExists1 = this.equipmentExists()
        let observations = this.observation.value && this.observation.value[0] !== undefined
        this.steppers = [
          {
            ref: 'commerce',
            fields: this.assignTo,
            title: 'Asignar al comercio'
          },
          {
            ref: 'seller',
            fields: [this.sellersParams || {}],
            title: 'Asignar al vendedor',
            icon_hidden: !this.isSuperadmin()
          },
          {
            ref: 'customer',
            fields: this.customer,
            title: 'Datos del cliente'
          },
          {
            ref: 'phones',
            fields: this.normalizeAndAssign([
              {
                assign_to: 'unknown',
                columns: 'xs12 sm12 md12 lg12',
                prepend_icon: 'phone',
                placeholder: 'Teléfono 1',
                editable: true,
                type: (phoneExists1 ? 'text-field' : 'hidden'),
                required: true,
                rules: [
                  'required'
                ],
                value: phoneExists1 ? this.phone.value[0].value : '',
                disabled: phoneExists1
              },
              {
                assign_to: 'unknown',
                columns: 'xs12 sm12 md12 lg12',
                prepend_icon: 'phone',
                placeholder: 'Teléfono 2',
                editable: true,
                type: (phoneExists2 ? 'text-field' : 'hidden'),
                value: phoneExists2 ? this.phone.value[1].value : '',
                disabled: phoneExists2
              },
              {
                assign_to: 'unknown',
                columns: 'xs12 sm12 md12 lg12',
                prepend_icon: 'phone',
                placeholder: 'Teléfono 3',
                editable: true,
                type: (phoneExists3 ? 'text-field' : 'hidden'),
                value: phoneExists3 ? this.phone.value[2].value : '',
                disabled: phoneExists3
              },
              {
                assign_to: 'unknown',
                disabled: phoneExists1 && phoneExists2 && phoneExists3,
                ref: 'add-phone',
                type: 'button',
                align: 'center',
                columns: 'xs12 sm12 md12 lg12',
                text_button: 'Agregar teléfono'
              }
            ]),
            title: 'Teléfonos de contacto'
          },
          {
            ref: 'address',
            fields: [
              this.route,
              this.routeExtras,
              this.postalCode,
              this.locality,
              this.province,
              this.placeID
            ],
            title: 'Dirección de cliente'
          },
          {
            ref: 'installationAddress',
            fields: [this.addressCheckbox],
            title: ''
          },
          {
            ref: 'address2',
            fields: [
              this.routeDelivery,
              this.routeExtrasDelivery,
              this.postalCodeDelivery,
              this.localityDelivery,
              this.provinceDelivery,
              this.placeIdDelivery
            ],
            title: 'Dirección de instalación'
          },
          {
            ref: 'equipments',
            fields: this.normalizeAndAssign([
              {
                assign_to: 'unknown',
                columns: 'xs12 sm12 md12 lg12',
                prepend_icon: 'inbox',
                placeholder: 'Equipo',
                type: (equipmmentExists1 ? 'text-field' : 'hidden'),
                required: true,
                rules: [
                  'required'
                ],
                value: equipmmentExists1 ? (this.bookingEquipments.value[0].brand + ' ' + this.bookingEquipments.value[0].model) : '',
                disabled: equipmmentExists1
              },
              {
                assign_to: 'unknown',
                disabled: equipmmentExists1,
                ref: 'add-equipment',
                type: 'button',
                align: 'center',
                columns: 'xs12 sm12 md12 lg12',
                text_button: 'Agregar equipo'
              }
            ]),
            title: 'Equipo a instalar'
          },
          {
            ref: 'preBooking',
            fields: this.normalizeAndAssign([
              {
                assign_to: 'unknown',
                columns: 'xs12 sm12 md12 lg12',
                prepend_icon: 'inbox',
                placeholder: 'Equipo',
                type: 'hidden',
                required: true,
                rules: [
                  'required'
                ],
                value: this.bookingWasSearch ? 'true' : '',
                disabled: this.bookingWasSearch
              },
              {
                assign_to: 'unknown',
                disabled: this.bookingWasSearch,
                ref: 'search-bookings',
                type: 'button',
                loading: false,
                align: 'center',
                columns: 'xs12 sm12 md12 lg12',
                text_button: 'Buscar'
              }
            ]),
            title: 'Buscar reservas disponibles para la instalación',
            subtitle: (this.bookingWasSearch && !this.hasAssignation) ? 'No se han encontrado instaladores disponibles en la zona del cliente. Desde Instalaciones BEC nos encargaremos de asignar la instalación una vez finalizada la reserva.' : (this.hasAssignation ? 'La reserva ha sido realizada.' : false)
          },
          {
            ref: 'installationInfo',
            fields: [
              this.installationInfo[0],
              this.installationInfo[1],
              this.installationInfo[2],
              this.installationInfo[3]
            ],
            title: 'Fecha y hora de la instalación'
          },
          {
            ref: 'installer',
            fields: [
              this.installationInfo[4]
            ],
            title: 'Asignar al instalador'
          },
          {
            ref: 'saleDeliveryDate',
            fields: [this.saleDeliveryDate],
            title: 'Fecha de entrega'
          },
          {
            ref: 'saleSoldDate',
            fields: [this.saleSoldDate],
            title: 'Fecha de venta'
          },
          {
            ref: 'requestImagesOnNew',
            fields: this.normalizeAndAssign([{
              ref: 'requestImagesOnNew',
              type: 'radio-group',
              assign_to: 'requestImagesOnNew',
              label: '¿Solicitar fotografías de la instalación?',
              columns: 'xs12',
              value: 'No',
              options: [
                {
                  value: 'yes',
                  label: 'Sí'
                },
                {
                  value: 'No',
                  label: 'No'
                }
              ]
            }])
          },
          {
            ref: 'saleDetails',
            fields: [
              this.fields[2],
              this.fields[3],
              this.fields[4]
            ],
            title: 'Detalles de la venta'
          },
          {
            ref: 'observations',
            fields: this.normalizeAndAssign([
              {
                assign_to: 'unknown',
                columns: 'xs12 sm12 md12 lg12',
                prepend_icon: 'inbox',
                placeholder: 'Observaciones',
                multi_line: true,
                type: (observations ? 'text-field' : 'hidden'),
                required: true,
                value: observations ? (this.observation.value[0].booking_observation_message || false) : '',
                disabled: true
              },
              {
                assign_to: 'unknown',
                disabled: observations,
                ref: 'add-observation',
                type: 'button',
                align: 'center',
                columns: 'xs12 sm12 md12 lg12',
                text_button: 'Agregar observaciones'
              }
            ]),
            title: 'Agregar observaciones',
            text: 'Siguiente'
          },
          {
            ref: 'document_1',
            fields: [
              {
                type: 'section-text',
                columns: 'xs12 sm12 md12 lg12',
                append_icon: 'help_outline',
                icon_color: 'primary',
                value: 'Antes de dar por terminada la reserva, se deben generar los siguientes documentos que deben ser firmados por el cliente:'
              },
              {
                type: 'section-text',
                icon_color: 'gray',
                assign_to: 'unknown',
                columns: 'xs12 sm12 md12 lg12',
                value: '1. CONFORMIDAD DE CLIENTE.'
              },
              {
                type: 'section-text',
                icon_color: 'gray',
                assign_to: 'unknown',
                columns: 'xs12 sm12 md12 lg12',
                value: '2. PARTE A – ANEXO VI – R.D. 115/2017.'
              }
            ],
            title: 'Generar documentos'
          },
          {
            ref: 'document_1_1',
            fields: [
              {
                type: 'section-text',
                append_icon: 'check_circle_outline',
                icon_color: 'gray',
                assign_to: 'unknown',
                columns: 'xs12 sm12 md12 lg12',
                value: '1. CONFORMIDAD DE CLIENTE:'
              },
              {
                assign_to: 'unknown',
                type: 'button',
                columns: 'xs12 sm12 md12 lg12',
                items: [
                  {
                    text_button: 'Imprimir y firmar',
                    align: 'right',
                    outline: true,
                    ref: 'upload-doc-1'
                  },
                  {
                    text_button: 'GENERAR y firmar en pantalla',
                    align: 'right',
                    outline: true,
                    open_new_window: true,
                    ref: 'signature-doc-1'
                  }
                ]
              }
            ],
            title: 'Generar documentos',
            button_hidden: true
          },
          {
            ref: 'document_1_2',
            fields: this.normalizeAndAssign([
              {
                assign_to: 'unknown',
                type: 'section-text',
                append_icon: 'check_circle_outline',
                icon_color: 'teal',
                columns: 'xs12 sm12 md12 lg12',
                value: '1. CONFORMIDAD DE CLIENTE.'
              },
              {
                assign_to: 'unknown',
                type: 'section-text',
                columns: 'xs12 sm12 md12 lg12',
                append_icon: 'check',
                icon_color: 'teal',
                value: 'El documento se ha actualizado correctamente.'
              },
              {
                assign_to: 'unknown',
                type: 'section-text',
                columns: 'xs12 sm12 md12 lg12',
                append_icon: 'help_outline',
                icon_color: 'primary',
                value: 'Aconsejamos entregar al cliente una copia de la conformidad firmada.'
              },
              {
                assign_to: 'unknown',
                type: this.customer[3].value ? 'button' : 'hidden',
                columns: 'xs12 sm12 md12 lg12',
                items: [
                  {
                    text_button: 'Enviar por email',
                    disabled: this.sendEmailDoc1 === true,
                    align: 'right',
                    outline: true,
                    ref: 'email-doc-1'
                  }
                ]
              },
              {
                assign_to: 'unknown',
                type: 'checkbox',
                columns: 'xs12 sm12 md12 lg12',
                label: 'Se ha entregado/enviado al cliente una copia firmada.',
                value: false,
                required: true,
                rules: [
                  'is_true'
                ]
              }
            ]),
            title: 'Generar documentos',
            icon_hidden: true
          },
          {
            ref: 'document_2',
            fields: [
              {
                type: 'section-text',
                append_icon: 'check_circle',
                icon_color: 'teal',
                assign_to: 'unknown',
                columns: 'xs12 sm12 md12 lg12',
                value: '1. CONFORMIDAD DE CLIENTE.'
              },
              {
                type: 'section-text',
                append_icon: 'check_circle_outline',
                icon_color: 'gray',
                assign_to: 'unknown',
                columns: 'xs12 sm12 md12 lg12',
                value: '2. PARTE A – ANEXO VI – R.D. 115/2017:'
              },
              {
                assign_to: 'unknown',
                type: 'button',
                columns: 'xs12 sm12 md12 lg12',
                items: [
                  {
                    text_button: 'Imprimir y firmar',
                    align: 'right',
                    outline: true,
                    ref: 'upload-doc-2'
                  },
                  {
                    text_button: 'GENERAR y firmar en pantalla',
                    align: 'right',
                    outline: true,
                    open_new_window: true,
                    ref: 'signature-doc-2'
                  }
                ]
              }
            ],
            title: 'Generar documentos',
            button_hidden: true,
            icon_hidden: true
          },
          {
            ref: 'document_2_1',
            fields: this.normalizeAndAssign([
              {
                assign_to: 'unknown',
                type: 'section-text',
                append_icon: 'check_circle',
                icon_color: 'teal',
                columns: 'xs12 sm12 md12 lg12',
                value: '1. CONFORMIDAD DE CLIENTE.'
              },
              {
                type: 'section-text',
                append_icon: 'check_circle',
                icon_color: 'teal',
                assign_to: 'unknown',
                columns: 'xs12 sm12 md12 lg12',
                value: '2. PARTE A – ANEXO VI – R.D. 115/2017.'
              },
              {
                assign_to: 'unknown',
                type: 'section-text',
                columns: 'xs12 sm12 md12 lg12',
                append_icon: 'check',
                icon_color: 'teal',
                value: 'El documento se ha actualizado correctamente.'
              },
              {
                assign_to: 'unknown',
                type: 'section-text',
                columns: 'xs12 sm12 md12 lg12',
                append_icon: 'help_outline',
                icon_color: 'primary',
                value: 'Aconsejamos entregar al cliente una copia del parte A firmada.'
              },
              {
                assign_to: 'unknown',
                type: this.customer[3].value ? 'button' : 'hidden',
                columns: 'xs12 sm12 md12 lg12',
                items: [
                  {
                    text_button: 'Enviar por email',
                    align: 'right',
                    outline: true,
                    disabled: this.sendEmailDoc2 === true,
                    ref: 'email-doc-2'
                  }
                ]
              },
              {
                assign_to: 'unknown',
                type: 'checkbox',
                columns: 'xs12 sm12 md12 lg12',
                label: 'Se ha entregado/enviado al cliente una copia firmada.',
                value: false,
                required: true,
                rules: [
                  'is_true'
                ]
              }
            ]),
            title: 'Generar documentos',
            icon_hidden: true
          },
          {
            ref: 'finish',
            fields: this.normalizeAndAssign([
              {
                assign_to: 'unknown',
                type: 'section-text',
                append_icon: 'check_circle',
                icon_color: 'teal',
                columns: 'xs12 sm12 md12 lg12',
                value: '1. CONFORMIDAD DE CLIENTE.'
              },
              {
                type: 'section-text',
                append_icon: 'check_circle',
                icon_color: 'teal',
                assign_to: 'unknown',
                columns: 'xs12 sm12 md12 lg12',
                value: '2. PARTE A – ANEXO VI – R.D. 115/2017.'
              },
              {
                assign_to: 'unknown',
                type: 'section-text',
                columns: 'xs12 sm12 md12 lg12',
                value: parseInt(this.calendar_visibility.value) === 1 ? 'ENHORABUENA ' + (this.fields[5] ? this.fields[5].value.seller_name : '') + ': queda confirmado que la reserva de instalación del cliente ' + (this.customer[0] ? this.customer[0].value : '') + ' ' + (this.customer[0] ? this.customer[1].value : '') + ', para el equipo ' + (this.bookingEquipments.value[0] ? this.bookingEquipments.value[0].model : '') + ', del tipo ' + (this.bookingEquipments.value[0] ? this.bookingEquipments.value[0].type : '') + ' se ha realizado correctamente.' : 'GRACIAS ' + (this.fields[5] ? this.fields[5].value.seller_name : '') + ', desde Instalaciones BEC ¡nos pondremos en contacto con el cliente lo antes posible para darle fecha y hora de instalación!.'
              },
              {
                assign_to: 'unknown',
                type: 'section-text',
                columns: 'xs12 sm12 md12 lg12',
                value: parseInt(this.calendar_visibility.value) === 1 ? 'A partir de aquí, desde Instalaciones BEC nos encargaremos del resto. Muchas gracias por tu colaboración.' : ''
              },
              {
                assign_to: 'unknown',
                type: 'button',
                columns: 'xs12 sm12 md12 lg12',
                items: [
                  {
                    text_button: 'Aceptar',
                    align: 'right',
                    outline: true,
                    ref: 'finish-booking'
                  }
                ]
              }
            ]),
            requestImagesOnNew: {},
            title: '¡RESERVA FINALIZADA!',
            text: 'Finalizar',
            icon_hidden: true
          },
          {
            ref: 'advise',
            fields: this.normalizeAndAssign([
              {
                assign_to: 'unknown',
                type: 'section-text',
                append_icon: 'check_circle',
                icon_color: 'teal',
                columns: 'xs12 sm12 md12 lg12',
                value: '1. CONFORMIDAD DE CLIENTE.'
              },
              {
                type: 'section-text',
                append_icon: 'check_circle',
                icon_color: 'teal',
                assign_to: 'unknown',
                columns: 'xs12 sm12 md12 lg12',
                value: '2. PARTE A – ANEXO VI – R.D. 115/2017.'
              },
              {
                type: 'section-text',
                append_icon: 'check_circle',
                icon_color: 'teal',
                assign_to: 'unknown',
                columns: 'xs12 sm12 md12 lg12',
                value: '3. PARTE B – ANEXO VI – R.D. 115/2017.'
              },
              {
                type: 'section-text',
                append_icon: 'check_circle',
                icon_color: 'teal',
                assign_to: 'unknown',
                columns: 'xs12 sm12 md12 lg12',
                value: '4. AVISO DE INSTALACIÓN.'
              },
              {
                assign_to: 'unknown',
                type: 'section-text',
                columns: 'xs12 sm12 md12 lg12',
                append_icon: 'help_outline',
                icon_color: 'primary',
                value: 'Los documentos se han generado correctamente. Puedes finalizar la reserva o enviar el aviso de instalación al comerciante. No es necesario enviar el aviso al instalador, el sistema lo enviará de forma automática 24 horas antes (48 horas si hay fiesta entre medio).'
              },
              {
                assign_to: 'unknown',
                type: 'button',
                columns: 'xs12 sm12 md12 lg12',
                items: [
                  {
                    text_button: 'Finalizar',
                    align: 'right',
                    outline: true,
                    ref: 'next-step'
                  },
                  {
                    text_button: 'Enviar aviso a comerciante',
                    align: 'right',
                    disabled: false,
                    loading: false,
                    outline: true,
                    ref: 'email-doc-4'
                  }
                ]
              }
            ]),
            requestImagesOnNew: {},
            title: 'Generar documentos',
            text: 'Siguiente',
            button_hidden: true,
            icon_hidden: true
          },
          {
            ref: 'finish',
            fields: this.normalizeAndAssign([
              {
                assign_to: 'unknown',
                type: 'section-text',
                append_icon: 'check_circle',
                icon_color: 'teal',
                columns: 'xs12 sm12 md12 lg12',
                value: '1. CONFORMIDAD DE CLIENTE.'
              },
              {
                type: 'section-text',
                append_icon: 'check_circle',
                icon_color: 'teal',
                assign_to: 'unknown',
                columns: 'xs12 sm12 md12 lg12',
                value: '2. PARTE A – ANEXO VI – R.D. 115/2017.'
              },
              {
                type: 'section-text',
                append_icon: 'check_circle',
                icon_color: 'teal',
                assign_to: 'unknown',
                columns: 'xs12 sm12 md12 lg12',
                value: '3. PARTE B – ANEXO VI – R.D. 115/2017.'
              },
              {
                type: 'section-text',
                append_icon: 'check_circle',
                icon_color: 'teal',
                assign_to: 'unknown',
                columns: 'xs12 sm12 md12 lg12',
                value: '4. AVISO DE INSTALACIÓN.'
              },
              {
                assign_to: 'unknown',
                type: 'section-text',
                columns: 'xs12 sm12 md12 lg12',
                value: '¡ENHORABUENA! Queda confirmado que la reserva de instalación del cliente ' + (this.customer[0] ? this.customer[0].value : '') + ' ' + (this.customer[0] ? this.customer[1].value : '') + ', para el equipo ' + (this.bookingEquipments.value[0] ? this.bookingEquipments.value[0].model : '') + ', del tipo ' + (this.bookingEquipments.value[0] ? this.bookingEquipments.value[0].type : '') + ' se ha realizado correctamente.'
              },
              {
                assign_to: 'unknown',
                type: 'button',
                columns: 'xs12 sm12 md12 lg12',
                items: [
                  {
                    text_button: 'Aceptar',
                    align: 'right',
                    outline: true,
                    ref: 'finish-booking'
                  }
                ]
              }
            ]),
            requestImagesOnNew: {},
            title: '¡INSTALACIÓN RESERVADA!',
            text: 'Finalizar',
            icon_hidden: true
          }
        ]
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      onNextStep (item, step, isValid) {
        console.log(item.ref)
        if (!isValid) {
          this.$awn.warning('Debes completar este paso antes de continuar')
        }
        // console.log('------>>>>', item.ref)
        // this.$refs.stepper.lastStep()
        // this.$refs.equipment_aggregator.openDialog()
        if (!this.isSuperadmin() && item.ref === 'customer') {
          if (parseInt(this.sellerID.value) === 1) {
            this.$refs.stepper.lastStep()
          }
        } else if (item.ref === 'commerce') {
          if (!this.isSuperadmin()) {
            this.$refs.stepper.nextStep()
          }
        } else if (item.ref === 'address') {
          this.$refs.editable_address_card_1.openDialog()
        } else if (item.ref === 'address2') {
          if (this.addressCheckbox.value === 'yes') {
            this.$refs.stepper.nextStep()
          } else {
            this.$refs.editable_address_card_2.openDialog()
          }
        } else if (item.ref === 'phones') {
          if (this.phone.value.length === 0) {
            this.$refs.phone_aggregator.openDialog()
          }
        } else if (item.ref === 'equipments') {
          if (this.bookingEquipments.value.length === 0) {
            return this.$refs.equipment_aggregator.openDialog()
          }
          if (parseInt(this.calendar_visibility.value) === 0) {
            this.$refs.stepper.nextStep()
            this.$refs.stepper.nextStep()
          }
        } else if (item.ref === 'preBooking') {
          if (!this.isSuperadmin() && parseInt(this.calendar_visibility.value) === 0) {
            this.$refs.stepper.nextStep()
            this.$refs.stepper.nextStep()
            this.$refs.stepper.nextStep()
          }
        } else if (item.ref === 'saleSoldDate') {
          this.onChange(this.fields[1].value, '8', this.fields[1], true)
        } else if (item.ref === 'installationInfo') {
          if (!this.isSuperadmin() && !this.hasAssignation) {
            this.$refs.stepper.nextStep()
            this.$refs.stepper.nextStep()
          }
        } else if (item.ref === 'installer') {
          if (!this.isSuperadmin() && !this.hasAssignation) {
            this.$refs.stepper.nextStep()
          }
        } else if (item.ref === 'document_1') {
          if (this.isSuperadmin()) {
            this.$refs.stepper.nextStep()
            this.$refs.stepper.nextStep()
            this.$refs.stepper.nextStep()
            this.$refs.stepper.nextStep()
            this.$refs.stepper.nextStep()
            this.$refs.stepper.nextStep()
          }
        } else if (item.ref === 'requestImagesOnNew') {
          if (!this.isSuperadmin()) {
            this.$refs.stepper.nextStep()
          }
        } else if (item.ref === 'customer_signature') {
          if (!this.bookingEquipments.value[0] || !this.bookingEquipments.value[0].serial_indoor_unit_1 || !this.bookingEquipments.value[0].serial_outdoor_unit_1) {
            this.$refs.stepper.lastStep()
            this.$awn.warning('Debes completar este paso antes de continuar')
          } else {
            this.hasSerials = true
            if (this.isSuperadmin()) {
              this.$refs.stepper.nextStep()
              this.$refs.stepper.nextStep()
            }
          }
        }
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      onLastStep (item, step, isValid) {
        // this.$refs.stepper.lastStep()
        // this.$refs.equipment_aggregator.openDialog()
        console.log('STEP', item.ref)
        this.currentStep = item.ref
        if (item.ref === 'address') {
          this.$refs.editable_address_card_1.openDialog()
        } else if (item.ref === 'address2') {
          if (this.addressCheckbox.value === 'yes') {
            this.$refs.stepper.lastStep()
          } else {
            this.$refs.editable_address_card_2.openDialog()
          }
        } else if (item.ref === 'installationInfo') {
          if (!this.isSuperadmin() && !this.hasAssignation) {
            this.$refs.stepper.lastStep()
          }
        } else if (item.ref === 'installer') {
          if (!this.isSuperadmin() && !this.hasAssignation) {
            this.$refs.stepper.lastStep()
            this.$refs.stepper.lastStep()
          }
          if (!this.isSuperadmin() && !this.hasAssignation && parseInt(this.calendar_visibility.value) === 0) {
            this.$refs.stepper.lastStep()
          }
        } else if (item.ref === 'commerce') {
          if (!this.isSuperadmin()) {
            this.$refs.stepper.lastStep()
          }
        } else if (item.ref === 'requestImagesOnNew') {
          if (!this.isSuperadmin()) {
            this.$refs.stepper.lastStep()
          }
        }
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      getAvailableBookings () {
        return new Promise((resolve, reject) => {
          this.$store.dispatch('api/authRequest', {
            method: 'post',
            url: 'get/bookings/available/' + this.commerceID.value + '/',
            data: {
              postalCode: this.postalCodeDelivery.value,
              locality: this.localityDelivery.value,
              province: this.provinceDelivery.value,
              placeID: this.placeIdDelivery.value,
              duration: parseInt(this.bookingEquipments.value[0].duration),
              quantity: parseInt(this.bookingEquipments.value[0].quantity)
            }
          }).then((response) => {
            console.log(response)
            resolve(response)
          }).catch((error) => {
            console.log(error)
            this.$store.dispatch(
              'snackbar/show',
              'Error al obtener reservas: ' + this.$store.getters['api/getMessage']
            )
            reject(error)
          })
        })
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      onAssignBooking (installerID, start, end) {
        console.log(installerID, start, end)
        this.hasAssignation = true
        this.setSteps()
        this.installerID.value = parseInt(installerID)
        this.updateItem(this.installerID, this.installerID.value)
        let index = this.installationInfo[4].items.findIndex((item) => {
          return parseInt(item[this.installationInfo[4].item_text_11]) === parseInt(installerID)
        })
        this.installationInfo[4].value = this.installationInfo[4].items[index]
        this.installationStartDate.value = this.moment(start).format('YYYY-MM-DD HH:mm')
        this.installationEndDate.value = this.moment(end).format('YYYY-MM-DD HH:mm')
        let startDate = this.installationStartDate.value
        this.updateItem(this.installationStartDate, this.installationStartDate.value)
        let endDate = this.installationEndDate.value
        this.updateItem(this.installationEndDate, this.installationEndDate.value)
        this.installationInfo[0].value = this.moment(startDate).format('YYYY-MM-DD')
        this.installationInfo[1].value = this.moment(endDate).format('YYYY-MM-DD')
        this.installationInfo[2].value = this.moment(startDate).format('HH:mm')
        this.installationInfo[3].value = this.moment(endDate).format('HH:mm')
        this.calendar = false
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      isSuperadmin () {
        return this.$store.getters['api/getUserRol'] === 'superadmin'
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      isNew () {
        return 213 === 'new'
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      isEdit () {
        return this.$route.name === 'booking-edit'
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      isView () {
        return this.$route.name !== 'booking-edit' && this.$route.name !== 'booking-new'
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      getTitle () {
        if (this.isView()) {
          return 'Detalles de la reserva'
        } else if (this.isEdit()) {
          return 'Editar reserva'
        }
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      onDelete () {
        return this.$route.name === 'booking-edit'
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      setSignature (toolbarTitle, fileTitle, filetype, filename) {
        // console.log(toolbarTitle, fileTitle, filetype, filename)
        this.signature.toolbar_title = toolbarTitle
        this.signature.booking_document_title = fileTitle
        this.signature.booking_document_filetype = filetype
        this.signature.booking_document_filename = filename
        this.$refs.signature.openDialog()
      },
      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      uploadInvoice () {
        this.$refs.document_aggregator.openDialog(
          'Subir factura de compra',
          'Factura de compra',
          true,
          'factura-compra-reserva-' + this.saleID.value + '.pdf'
        )
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      generateDoc (type, documentID) {
        this.currentDocumentID = documentID
        if (type === 'signature') {
          if (documentID === 1) {
            this.isSignature = true
            this.generateDocument(documentID, true)
            this.setSignature(
              'Firmar documento: Conformidad Cliente',
              'Firma documento: Conformidad Cliente',
              'image/png',
              'firma-documento-conformidad-cliente.png'
            )
          } else if (documentID === 2) {
            this.isSignature = true
            this.generateDocument(documentID, true)
            this.setSignature(
              'Firmar documento: Parte A',
              'Firma documento: Parte A',
              'image/png',
              'firma-documento-parte-a.png'
            )
          } else if (documentID === 3) {
            this.isSignature = true
            this.generateDocument(documentID, true)
            this.setSignature(
              'Firmar documento: Parte B',
              'Firma documento: Parte B',
              'image/png',
              'firma-documento-parte-b.png'
            )
          }
        } else {
          if (documentID === 1) {
            this.isSignature = false
            this.generateDocument(documentID, true)
            this.$refs.document_aggregator.openDialog(
              'Adjuntar conformidad firmada por el cliente',
              'Documento Conformidad Cliente',
              true
            )
          } else if (documentID === 2) {
            this.isSignature = false
            this.generateDocument(documentID, true)
            this.$refs.document_aggregator.openDialog(
              'Adjuntar parte A firmado por el cliente',
              'Documento Parte A',
              true
            )
          } else if (documentID === 3) {
            this.isSignature = false
            this.generateDocument(documentID, true)
            this.$refs.document_aggregator.openDialog(
              'Adjuntar parte B firmado por el cliente',
              'Documento Parte B',
              true
            )
          }
        }
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      serialsAndSignatureExists (documentID, openFile) {
        return new Promise((resolve, reject) => {
          this.$store.dispatch('api/authRequest', {
            method: 'get',
            url: 'bookings/signature/exists/' + this.bookingID.value + '/'
          }).then((response) => {
            console.log('resp', response)
            if (this.isInstaller() && response.data !== true) {
              this.setInstallerSteps()
              this.noAssignation = true
              console.log('this.hasSerials', this.hasSerials)
              if (this.hasSerials) {
                this.$refs.stepper.nextStep()
                return resolve(true)
              } else {
                this.addingSerials = true
              }
              return resolve(false)
            } else if (this.isSuperadmin() && !this.hasSerials) {
              this.setInstallerSteps()
              this.noAssignation = true
              return resolve(false)
            }
            resolve(true)
          })
        })
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      generateDocument (documentID, openFile) {
        openFile && this.openNewWindow()
        if (documentID === 3) {
          this.serialsAndSignatureExists().then((response) => {
            console.log('vvvvvvvvv', response)
            if (!response) {
              this.newWindowContent.close()
              return false
            } else {
              return new Promise((resolve, reject) => {
                this.$store.dispatch('api/authRequest', {
                  method: 'get',
                  url: 'bookings/document/' + documentID + '/' + this.saleID.value + '/'
                }).then((response) => {
                  if (openFile) {
                    this.newWindowContent.location.href = response.data
                  }
                  resolve(response)
                }).catch((error) => {
                  console.log(error)
                  this.$store.dispatch(
                    'snackbar/show',
                    'Error al generar el documento: ' + this.$store.getters['api/getMessage']
                  )
                  reject(error)
                })
              })
            }
          })
        } else {
          return new Promise((resolve, reject) => {
            this.$store.dispatch('api/authRequest', {
              method: 'get',
              url: 'bookings/document/' + documentID + '/' + this.saleID.value + '/'
            }).then((response) => {
              console.log('$$$$$$$$$$$', response.data)
              // console.log(response)
              if (openFile) {
                this.newWindowContent.location.href = response.data
              }
              resolve(response)
            }).catch((error) => {
              console.log(error)
              this.$store.dispatch(
                'snackbar/show',
                'Error al generar el documento: ' + this.$store.getters['api/getMessage']
              )
              reject(error)
            })
          })
        }
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      onChangeSignature (item) {
        if (this.isNew() || this.addingSerials) {
          this.$refs.stepper.nextStep()
        }
        this.signature.booking_document_url = item.value
        this.generateDocument(this.currentDocumentID, true)
        this.onAddDocument(this.signature)
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      isAssignated () {
        return this.installationInfo[0].value && this.installationInfo[1].value && this.installationInfo[2].value && this.installationInfo[4].value
      },

      normalizeAddress () {
        this.normalizeAndAssign([{
          ref: 'installationAddress',
          type: 'radio-group',
          label: '¿La instalación se ha de realizar en la dirección indicada?',
          columns: 'xs12',
          assign_to: 'addressCheckbox',
          value: null,
          options: [
            {
              value: 'yes',
              label: 'Sí'
            },
            {
              value: 'No',
              label: 'No'
            }
          ],
          rules: [
            'required'
          ],
          required: true
        }])
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      onFinish () {
        let userID = parseInt(this.$store.getters['api/getUserId'])
        this.$store.dispatch('api/authRequest', {
          method: 'get',
          url: 'email-new-booking/' + userID + '/' + this.saleID.value + '/'
        }).then((response) => {
          this.$router.push({
            name: 'booking-added',
            params: {
              booking_id: this.saleID.value,
              booking_added: 'true'
            }
          })
          // console.log(response)
        }).catch(() => {
          let message = this.$store.getters['api/getMessage']
          this.$awn.alert('Error al enviar email informativo: ' + message)
        })
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      normalizeAndAssign (params) {
        let filter = (param, def) => {
          return (typeof param !== 'undefined') ? param : def
        }
        params.map((obj, index) => {
          obj.editable = filter(obj.editable, true)
          obj.label = filter(obj.label, undefined)
          obj.hint = filter(obj.hint, 'Pulsa enter para guardar')
          obj.no_data_text = filter(obj.no_data_text, 'Pulsa enter para agregar:')
          obj.ref = filter(obj.ref, '')
          obj.order = filter(obj.order, '')
          obj.assign_to = filter(obj.assign_to, 'fields')
          obj.value_class = filter(obj.value_class, '')
          obj.tooltip = filter(obj.tooltip, 'Pulsa para editar')
          obj.focus_next_on_enter = filter(obj.focus_next_on_enter, true)
          obj.dark = filter(obj.dark, false)
          obj.color = filter(obj.color, 'primary')
          obj.columns = filter(obj.columns, 'xs12 sm6 md6 lg6')
          obj.counter = filter(obj.counter, false)
          obj.dialog = filter(obj.dialog, false)
          obj.required = filter(obj.required, false)
          obj.type = filter(obj.type, 'select')

          obj.disabled = filter(obj.disabled, false)
          obj.update = filter(obj.update, true)
          obj.add_on_enter = filter(obj.add_on_enter, false)
          obj.autocomplete = filter(obj.autocomplete, obj.ref)
          obj.rules = filter(obj.rules, [])
          obj.rules = this.setRules(obj.rules)
          let assignTo = Array.isArray(obj.assign_to) ? obj.assign_to : [obj.assign_to]

          assignTo.forEach((item) => {
            if (Array.isArray(this[item])) {
              this[item].push(obj)
            } else {
              this[item] = obj
            }
          })
        })
        return params
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      getObservations () {
        return new Promise((resolve, reject) => {
          let bookingID = 213
          this.$store.dispatch('api/authRequest', {
            method: 'get',
            url: 'booking/observations/' + bookingID + '/'
          }).then((response) => {
            this.observation.items = response.data
            // console.log(response)
            resolve(response)
          }).catch((error) => {
            console.log(error)
            this.$store.dispatch(
              'snackbar/show',
              'Error al obtener observaciones: ' + this.$store.getters['api/getMessage']
            )
            reject(error.response)
          })
        })
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      openNewWindow () {
        if (this.newWindowContent === null || (this.newWindowContent && this.newWindowContent.closed)) {
          this.newWindowContent = window.open('', '_blank')
        }
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      getDocuments () {
        return new Promise((resolve, reject) => {
          let bookingID = 213
          this.$store.dispatch('api/authRequest', {
            method: 'get',
            url: 'booking/documents/' + bookingID + '/'
          }).then((response) => {
            // console.log(response)
            this.documents.items = response.data
            // console.log(response)
            resolve(response)
          }).catch((error) => {
            console.log(error)
            this.$store.dispatch(
              'snackbar/show',
              'Error al obtener el documento: ' + this.$store.getters['api/getMessage']
            )
            reject(error)
          })
        })
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      onCloseStepper () {
        this.$router.go(-1)
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      getEquipments () {
        return new Promise((resolve, reject) => {
          this.$store.dispatch('api/authRequest', {
            method: 'get',
            url: 'equipments/'
          }).then((response) => {
            // console.log(response.data)
            resolve(response)
          }).catch((error) => {
            console.log(error)
            this.$store.dispatch(
              'snackbar/show',
              'Error al obtener equipos: ' + this.$store.getters['api/getMessage']
            )
            reject(error.response)
          })
        })
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      deleteObservation (index, item) {
        this.$store.dispatch('api/authRequest', {
          method: 'delete',
          url: 'booking/observations/' + item.booking_observation_id + '/'
        }).then((response) => {
          // console.log(response)
          this.observation.items.splice(index, 1)
          if (!this.isNew()) {
            this.$awn.success('Observación eliminada')
          }
        }).catch(() => {
          let message = this.$store.getters['api/getMessage']
          this.$awn.alert('Error al eliminar la observación: ' + message)
        })
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      congratulations () {
        this.$refs.observation_aggregator.openAggregator('3', '¡Buen trabajo!', '¡Buen trabajo!', 'congratulations', false)
        this.$refs.observation_aggregator.addObservation()
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      equipmentExists () {
        return this.bookingEquipments.value && this.bookingEquipments.value[0] !== undefined
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      deleteDocument (index, item) {
        this.$store.dispatch('api/authRequest', {
          method: 'delete',
          url: 'booking/documents/' + item.booking_document_id + '/'
        }).then((response) => {
          // console.log(response)
          this.documents.items.splice(index, 1)
          if (!this.isNew()) {
            this.$awn.success('Documento eliminado')
          }
        }).catch(() => {
          let message = this.$store.getters['api/getMessage']
          this.$awn.alert('Error al eliminar la observación: ' + message)
        })
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      onAddObservation (item) {
        this.setSteps()
        item.user_id = parseInt(this.$store.getters['api/getUserId'])
        item.booking_id = parseInt(this.bookingID.value)
        item.sale_id = parseInt(this.saleID.value)
        this.$store.dispatch('api/authRequest', {
          method: 'post',
          url: 'booking/observations/',
          data: item
        }).then((response) => {
          // console.log(response.data)
          delete item.sale_id
          item.booking_observation_id = response.data
          item.booking_observation_user = 'Tú'
          this.observation.items.push(item)
          if (!this.isNew()) {
            this.$awn.success('Nota agregada')
          }
        }).catch((error) => {
          console.log(error)
          let message = this.$store.getters['api/getMessage']
          this.$awn.alert('Error al agregar la nota: ' + message)
        })
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      onAddDocument (item) {
        console.log(item)
        item.user_id = parseInt(this.$store.getters['api/getUserId'])
        item.booking_id = parseInt(this.bookingID.value)
        this.$store.dispatch('api/authRequest', {
          method: 'post',
          url: 'booking/documents/',
          data: item
        }).then((response) => {
          if (this.isNew()) {
            this.$refs.stepper.nextStep()
          }
          // console.log(response.data)
          item.booking_document_id = response.data
          item.booking_document_user = 'Tú'
          this.documents.items.push(item)
          if (item.booking_document_filename === 'factura-compra-reserva-' + this.saleID.value + '.pdf') {
            this.sendEmail('email-invoice-admin')
            this.invoice[0].value = true
          }
          if (!this.isNew()) {
            this.$awn.success('Documento agregado')
          }
          if ((this.isNew() || this.addingSerials) && this.isSignature) {
            this.generateDocument(this.currentDocumentID, true)
          }
        }).catch((error) => {
          console.log(error)
          let message = this.$store.getters['api/getMessage']
          this.$awn.alert('Error al agregar el documento: ' + message)
        })
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      onAddEquipment (item) {
        if (this.isNew()) {
          this.setSteps()
        }
        this.onChange(this.bookingEquipments.value, null, this.bookingEquipments, true)
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      deleteEquipment (index, item) {
        this.onChange(this.bookingEquipments.value, null, this.bookingEquipments, true)
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      getCommerces () {
        return new Promise((resolve, reject) => {
          this.$store.dispatch('api/authRequest', {
            method: 'get',
            url: 'user/active-commerces/'
          }).then((response) => {
            let index = response.data.items.findIndex((item) => {
              return parseInt(item[response.data.item_text]) === parseInt(this.commerceID.value)
            })
            response.data.value = response.data.items[index]
            response.data.item_text = response.data.item_text_3
            response.data.item_value = response.data.item_value
            this.normalizeAndAssign([response.data])
            resolve(response)
          }).catch((error) => {
            console.log(error)
            this.$store.dispatch(
              'snackbar/show',
              'Error al obtener comercios: ' + this.$store.getters['api/getMessage']
            )
            reject(error.response)
          })
        })
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      getInstallers () {
        return new Promise((resolve, reject) => {
          this.$store.dispatch('api/authRequest', {
            method: 'get',
            url: 'user/active-installers/'
          }).then((response) => {
            let index = response.data.items.findIndex((item) => {
              return parseInt(item[response.data.item_text]) === parseInt(this.installerID.value)
            })

            response.data.items.map((obj, index) => {
              // obj[response.data.item_text_2] = obj[response.data.item_text_11] + ' ' + obj[response.data.item_text_3]
              obj[response.data.item_text_2] = obj[response.data.item_text_12]
              return obj
            })
            response.data.value = response.data.items[index]
            response.data.item_text = response.data.item_text_2
            response.data.item_value = response.data.item_value
            this.normalizeAndAssign([response.data])
            resolve(response)
          }).catch((error) => {
            console.log(error)
            this.$store.dispatch(
              'snackbar/show',
              'Error al obtener instaladores: ' + this.$store.getters['api/getMessage']
            )
            reject(error.response)
          })
        })
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      getCommerceSellers () {
        return new Promise((resolve, reject) => {
          this.$store.dispatch('api/authRequest', {
            method: 'get',
            url: 'user/commerce/sellers/' + this.commerceID.value + '/'
          }).then((response) => {
            this.sellersParams.items = response.data
            let index = this.sellersParams.items.findIndex((item) => {
              return parseInt(item.seller_id) === parseInt(this.sellerID.value)
            })
            if (index > -1) {
              this.sellerID.value = this.sellersParams.items[index].seller_id
              this.sellersParams.value = this.sellersParams.items[index]
            } else {
              this.sellerID.value = this.sellersParams.items[0].seller_id
              this.sellersParams.value = this.sellersParams.items[0]
            }
            if (!this.fields[5]) {
              this.normalizeAndAssign([this.sellersParams])
            }

            // console.log(response)
            resolve(response)
          }).catch((error) => {
            console.log(error)
            let message = this.$store.getters['api/getMessage']
            this.$awn.alert('Error al obtener vendedores: ' + message)
            reject(error.response)
          })
        })
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      onChangeAvatar (item) {
        // this.onChange(item.value, null, item, true)
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      onUploadError (type, requiredValue) {
        let errors = {
          'format': 'ERROR: La imagen debe tener un formato: ' + requiredValue,
          'max-file-size': 'ERROR: La imagen no debe superar los ' + (requiredValue / 1000) + 'kB',
          'width': 'ERROR: La imagen debe tener un ancho de ' + requiredValue + 'px',
          'height': 'ERROR: La imagen debe tener un alto de ' + requiredValue + 'px'
        }
        this.$awn.alert(errors[type])
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      onEdit () {
        this.$router.push({
          name: 'booking-edit',
          params: {
            booking_id: this.saleID.value
          }
        })
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      addRates () {
        let fields = [
          {
            assign_to: 'fields',
            type: 'text-field',
            columns: 'xs4',
            label: 'Precio instalación (1)',
            disabled: true,
            editable: true,
            static_field: true,
            appendText: '€',
            value: ''
          },
          {
            assign_to: 'fields',
            type: 'text-field',
            columns: 'xs4',
            label: 'Precio instalación (2)',
            disabled: true,
            editable: true,
            static_field: true,
            appendText: '€',
            value: ''
          },
          {
            assign_to: 'fields',
            type: 'text-field',
            columns: 'xs4',
            label: 'Precio instalación (3)',
            disabled: true,
            editable: true,
            static_field: true,
            appendText: '€',
            value: ''
          }
        ]
        this.normalizeAndAssign(fields)
        this.setRatesValues()
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      setRatesValues () {
        if (this.fields[0].value) {
          this.fields[1].value = this.fields[0].value[this.fields[0].item_text_2]
          this.fields[2].value = this.fields[0].value[this.fields[0].item_text_3]
          this.fields[3].value = this.fields[0].value[this.fields[0].item_text_4]
        }
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      onClickButton (item, isValid) {
        if (item.newWindowContent) {
          this.newWindowContent = item.newWindowContent
        }
        if (item.ref === 'add-phone') {
          this.$refs.phone_aggregator.openDialog()
        } else if (item.ref === 'add-equipment') {
          this.$refs.equipment_aggregator.openDialog()
        } else if (item.ref === 'add-observation') {
          this.$refs.observation_aggregator.openAggregator('1', 'Observaciones - Reserva', '', 'first-observation', true, true)
        } else if (item.ref === 'signature-doc-1') {
          this.generateDoc('signature', 1)
        } else if (item.ref === 'upload-doc-1') {
          this.generateDoc('upload', 1)
        } else if (item.ref === 'signature-doc-2') {
          this.generateDoc('signature', 2)
        } else if (item.ref === 'upload-doc-2') {
          this.generateDoc('upload', 2)
        } else if (item.ref === 'signature-doc-3') {
          this.generateDoc('signature', 3)
        } else if (item.ref === 'upload-doc-3') {
          this.generateDoc('upload', 3)
        } else if (item.ref === 'next-step') {
          this.$refs.stepper.onNext()
        } else if (item.ref === 'invoice-was-updated') {
          this.uploadInvoice()
        } else if (item.ref === 'finish-serials') {
          this.hasSerials = true
          this.noAssignation = false
          this.addingSerials = false
          this.generateDocument(3, true)
          setTimeout(() => { location.reload() }, 500)
        } else if (item.ref === 'finish-booking') {
          this.generateDocument(4, false)
          if (this.noAssignation) {
            location.reload()
          }
          this.installationStateForm[0].value = this.installationStateCausesForm[0].items[0]
          this.$router.push({
            name: 'booking-added',
            params: {
              booking_id: this.saleID.value,
              booking_added: 'true'
            }
          })
        } else if (item.ref === 'search-bookings') {
          setTimeout(() => {
            this.bookingWasSearch = true
            this.getAvailableBookings().then((response) => {
              if (response.data.items && response.data.items.length > 0) {
                this.$refs.calendar.renderShedules(response.data)
                this.calendar = true
                return true
              }

              this.setSteps()
            }).catch((error) => {
              console.log(error)
            })
          }, 100)
        } else if (item.ref === 'email-doc-1') {
          this.sendEmailDoc1 = true
          this.setSteps()
          this.sendEmail('email-doc-1')
        } else if (item.ref === 'email-doc-2') {
          this.sendEmailDoc2 = true
          this.setSteps()
          this.sendEmail('email-doc-2')
        } else if (item.ref === 'email-doc-3') {
          this.sendEmailDoc3 = true
          // this.setSteps()
          this.sendEmail('email-doc-3')
        } else if (item.ref === 'email-doc-4') {
          if (this.isNew()) {
            item.disabled = true
            item.loading = true
            this.setSteps()
          }
          this.generateDocument(4, false)
          setTimeout(() => { this.sendEmail('email-doc-4') }, 1000)
        } else if (item.ref === 'serial-numbers') {
          this.$refs.equipment_aggregator.openMessage(0)
        }
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      onChangePhone () {
        this.setSteps()
        this.onChange(this.phone.value, null, this.phone, true)
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      sendEmail (type) {
        let customerName = this.customer[0].value + ' ' + this.customer[1].value
        let commerceName = this.commerceName.value
        let email = this.customer[3].value
        let soldDate = this.moment(this.saleSoldDate.value || this.moment()).format('DD-MM-YYYY')
        let equipmentBrand = this.bookingEquipments.value[0].brand
        let equipmentModel = this.bookingEquipments.value[0].model
        let commerceID = this.commerceID.value

        if (type === 'email-doc-4') {
          email = this.commerceEmail.value
        }
        return new Promise((resolve, reject) => {
          this.$store.dispatch('api/authRequest', {
            method: 'post',
            url: 'email/' + type + '/',
            data: {
              sale_id: this.saleID.value,
              customer_name: customerName,
              commerce_name: commerceName,
              email: email,
              commerce_id: commerceID,
              sold_date: soldDate,
              equipment_brand: equipmentBrand || '',
              equipment_model: equipmentModel || ''
            }
          }).then((response) => {
            this.$awn.success('Email enviado')
            console.log(response)
            resolve(response)
          }).catch((error) => {
            console.log(error)
            this.$awn.alert('Error al enviar el email: ' + this.$store.getters['api/getMessage'])
            reject(error.response)
          })
        })
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      getSale () {
        return new Promise((resolve, reject) => {
          let bookingID = 213
          this.$store.dispatch('api/authRequest', {
            method: 'get',
            url: 'sale/' + bookingID + '/'
          }).then((response) => {
            console.log(response.data)
            resolve(response)
          }).catch((error) => {
            console.log(error)
            this.$awn.alert('Error al obtener datos de la reserva: ' + this.$store.getters['api/getMessage'])
            reject(error.response)
          })
        })
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      onChange (newVal, oldVal, item, isValid) {
        if (item.update && this.$store.getters['api/getStatus'] !== 'loading') {
          if (this.display && isValid) {
            item.value = newVal
            if (newVal && item.type === 'select') {
              if (item.ref === 'sellerID') {
                this.updateItem(this.sellerID, newVal[item.item_value])
              } else if (item.assign_to === 'newInstallation') {
                this.$refs.observation_aggregator.openAggregator('1', 'Solicitar nueva instalación', newVal.item_value, 'get-new-installation', false)
                this.$refs.observation_aggregator.addObservation()
              } else if (item.assign_to === 'requestImages') {
                this.$refs.observation_aggregator.openAggregator('1', 'Hacer fotografías', newVal.item_value, 'take-pictures', false)
                this.$refs.observation_aggregator.addObservation()
              } else if (item.ref === 'installerID') {
                // console.log(newVal[item.item_text_11])
                this.updateItem(this.installerID, newVal[item.item_text_11])
              } else if (item.ref === 'commerceID') {
                this.commerceName.value = newVal[item.item_text_3]
                this.companyName.value = newVal[item.item_text_4]
                this.commerceEmail.value = newVal[item.item_text_10]
                this.businessGroupName.value = newVal[item.item_text_5]
                this.businessGroupType.value = newVal[item.item_text_12]
                this.commerceType.value = newVal[item.item_text_13]
                this.commerceID.value = newVal[item.item_text_14]
                this.getCommerceSellers()
              } else {
                this.updateItem(item, newVal[item.item_value])
              }
            } else if ((item.type === 'text-field' || item.type === 'hidden') && !item.static_field) {
              this.updateItem(item, item.value)
            } else if (item.type === 'checkbox' && item.assign_to === 'invoice') {
              this.updateItem(item, item.value ? 1 : 0)
            } else if (item.type === 'date-picker' || item.type === 'time-picker') {
              if (item.ref === 'installationStartDate') {
                let installationStartDate = this.installationInfo[0].value + ' ' + this.installationInfo[2].value
                installationStartDate = this.moment(installationStartDate).format('YYYY-MM-DD HH:mm:ss')
                this.updateItem(this.installationStartDate, installationStartDate)
              } else if (item.ref === 'installationEndDate') {
                let installationEndDate = this.installationInfo[1].value + ' ' + this.installationInfo[3].value
                installationEndDate = this.moment(installationEndDate).format('YYYY-MM-DD HH:mm:ss')
                this.updateItem(this.installationEndDate, installationEndDate)
              } else {
                let date = this.moment(item.value + ' 00:00:00').format('YYYY-MM-DD HH:mm:ss')
                item.assign_to = Array.isArray(item.assign_to) ? item.assign_to[1] : item.assign_to
                this.updateItem(item, date)
              }
            } else if (item.type === 'image') {
              this.updateItem(item, item.value)
            }
          }
        }
        if (this.display && newVal && item.ref === 'installation_state') {
          if (this.installationStateCausesForm && parseInt(newVal.item_value) === 8) {
            this.showStateCauses = true
          } else {
            this.showStateCauses = false
            this.installationStateCausesForm[0].value = ''
            this.updateItem(this.installationStateCausesForm[0], this.installationStateCausesForm[0].value)
          }
          if (parseInt(newVal.item_value) === 11) {
            this.$refs.observation_aggregator.openAggregator('2', 'Terminada con incidencias')
          }
        }
        if (this.display && newVal && item.ref === 'installation_state_causes') {
          if (parseInt(newVal.item_value) === 5) {
            this.$refs.observation_aggregator.openAggregator('2', 'Instalación anulada', 'Motivo: ')
          }
        }
        if (item.type === 'radio-group' && this.isNew()) {
          if (item.ref === 'requestImagesOnNew') {
            if (this.requestImagesOnNew.value === 'yes') {
              this.$refs.observation_aggregator.openAggregator('1', 'Hacer fotografías', 'Hacer fotografías a la instalación. En caso de no ser posible, agregar observación informando sobre el motivo.', 'take-pictures', false)
              this.$refs.observation_aggregator.addObservation()
            }
          }
        }
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      validateEquipment () {
        let equipment = this.$refs.equipment.$refs.form_creator.validateForm()
        let commerce = this.$refs.commerce.$refs.form_creator.validateForm()
        let fields = this.$refs.fields.$refs.form_creator.validateForm()
        if (equipment && commerce && fields) {
          this.onChange('1', null, this.status, true)
          this.$router.push(
            {
              name: 'equipments'
            }
          )
        }
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      returnToEquipments () {
        this.$router.push(
          {
            name: 'equipments'
          }
        )
        this.deleteEquipment(this.equipmentID)
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      normalizeModels (item) {
        let currentBrandID = item.value[item.item_value]

        if (item.brands_relations[currentBrandID]) {
          if (!this.models) {
            this.models = this.equipment[2].items
          }
          let brandModels = item.brands_relations[currentBrandID]

          let items = []
          this.models.forEach(obj => {
            let modelID = obj[this.equipment[2].item_value]

            if (brandModels.indexOf(modelID) > -1) {
              items.push(obj)
            }
          })
          this.equipment[2].items = items
          this.equipment[2].value = items ? items[0] : []
        } else {
          this.equipment[2].items = []
          this.equipment[2].value = ''
        }
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      onAddItem (newVal, oldVal, item, isValid) {
        let equipmentID = this.equipmentID
        this.$store.dispatch('api/authRequest', {
          method: 'post',
          url: 'equipment/' + equipmentID + '/',
          data: {
            controller: item.item_controller,
            value: newVal[item.item_text]
          }
        }).then((response) => {
          newVal[item.item_value] = response.data
          item.items.unshift(newVal)
          this.onChange(item.items[0], oldVal, item, isValid)
        }).catch((error) => {
          console.log(error)
          this.$awn.alert('Al agregar nuevo elemento')
        })
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      updateItem (item, value) {
        let url = ''
        // console.log(item.assign_to)
        switch (item.assign_to) {
          case 'bookingEquipments':
            url = 'sale/' + this.bookingID.value + '/'
            this.update(item, value, url)
            break
          case 'customer':
          case 'routeDelivery':
          case 'routeExtrasDelivery':
          case 'postalCodeDelivery':
          case 'localityDelivery':
          case 'provinceDelivery':
          case 'placeIdDelivery':
          case 'route':
          case 'routeExtras':
          case 'postalCode':
          case 'locality':
          case 'province':
          case 'placeID':
          case 'phone':
            url = 'customer/' + this.customerID.value + '/'
            this.update(item, value, url)
            break
          case 'invoice':
          case 'fields':
          case 'sellerID':
          case 'saleDeliveryDate':
          case 'saleSoldDate':
          case 'statusID':
            url = 'sale/' + this.saleID.value + '/'
            this.update(item, value, url)
            break
          case 'installationStateForm':
          case 'installationStateCausesForm':
          case 'installerID':
          case 'installationStartDate':
          case 'installationEndDate':
            url = 'bookings/' + this.bookingID.value + '/'
            this.update(item, value, url)
            break
        }
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      update (item, value, url) {
        this.$store.dispatch('api/authRequest', {
          method: 'put',
          url: url,
          data: {
            table: item.table,
            column: item.column,
            data_type: item.data_type,
            value: value
          }
        }).then((response) => {
          // console.log(response)
          if (!this.isNew() && !this.noAssignation) {
            this.$awn.success('¡Hecho!')
          }
        }).catch((error) => {
          console.log(error)
          this.$awn.alert('Al actualizar')
        })
      }
    },
    watch: {
      'addressCheckbox.value': {
        handler: function (newVal, oldVal) {
          if (this.isNew()) {
            if (newVal === 'yes') {
              this.routeDelivery.value = this.route.value
              this.routeExtrasDelivery.value = this.routeExtras.value
              this.postalCodeDelivery.value = this.postalCode.value
              this.localityDelivery.value = this.locality.value
              this.provinceDelivery.value = this.province.value
              this.placeIdDelivery.value = this.placeID.value
            } else {
              this.routeDelivery.value = ''
              this.routeExtrasDelivery.value = ''
              this.postalCodeDelivery.value = ''
              this.localityDelivery.value = ''
              this.provinceDelivery.value = ''
              this.placeIdDelivery.value = ''
            }
          }
        },
        deep: true
      },
      display: {
        handler: function (newVal, oldVal) {
          // console.log('------$------', this.commerceID)
          if (this.isCommerce()) {
            this.$refs.stepper.nextStep()
          }
        },
        deep: true
      }
    }
  }
</script>

<style lang="sass">

.application
  background: rgba(63, 81, 181, 0.07058823529411765) !important

a
 text-decoration: none

.image 
  cursor: pointer

.flex
  /* padding: 5px 12px */

.container.grid-list-xl *:not(:only-child) .layout:first-child
  margin-top: 0px

.jst-card
  margin-bottom: 20px

.installer
  margin-top: -33px !important
  font-weight: 100
  display: -webkit-box
  width: 100%

.carousel-actions
  padding: 18px

.carousel
  height: 250px
  width: 250px
  margin: 0 auto
  box-shadow: none

.input-file
  display: none

.image-info
  width: 72%

.add-address
  display: hidden

.address-autocomplete
  max-width: 435px
  margin: 0 auto
  padding: 32px 0 32px 0

.list-item
  display: inline-block
  margin-right: 10px

.list-enter-active, .list-leave-active
  transition: all 1s

.list-enter, .list-leave-to
  opacity: 0
  transform: translateY(30px)

html
  overflow-y: visible !important

.profile-options
  float: right
  bottom: 62px

.disable-area
  opacity: 0.5;
  pointer-events: none;
  cursor: default;
  text-decoration: none;
  -webkit-transition: opacity 1s ease-in-out;
  -moz-transition: opacity 1s ease-in-out;
  -ms-transition: opacity 1s ease-in-out;
  -o-transition: opacity 1s ease-in-out;
  transition: opacity 1s ease-in-out;

.commerce
  font-weight: 100

.carousel-actions
  padding: 18px

.carousel
  height: 250px
  width: 250px
  margin: 0 auto
  box-shadow: none

.center-btn-booking
  margin: auto
  margin-top: 16px
  margin-bottom: 16px
  display: block

.document-advise
  margin-top: 8px
  margin-bottom: 8px
  display: block

.vrg-title
  color: rgba(0, 0, 0, 0.54)
  display: block !important

.alert > div
  align-self: center
  flex: 1 1
  text-align: left
  font-size: 16px

.alert
  margin-bottom: 18px
</style>



// WEBPACK FOOTER //
// src/pages/booking-new.vue